import { Command, CommandDisabledReason } from '@nest/internal-frontend';
import { useValidationResultDialog } from '@nest/uikit-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Truck } from 'lucide-react';
import { useMemo } from 'react';
import { toast } from 'sonner';
import { useTerminalClient } from '../../../client-rpc-router';

export const useCommandOutboundDeliveryOrderCreateShipment = ({ id, shipmentCreated }: { id?: number; shipmentCreated?: boolean }): Command => {
	const client = useTerminalClient();
	const queryClient = useQueryClient();

	const disabledReasons = useMemo<CommandDisabledReason[]>(() => {
		const reasons: CommandDisabledReason[] = [];

		if (shipmentCreated === true) {
			reasons.push('Zásilka již byla vytvořena.');
		}

		return reasons;
	}, [shipmentCreated]);

	const mutation = useMutation({
		mutationFn: () => client.outboundDeliveryOrders.createOutboundDeliveryOrderShipmentMutation.execute({ id: id! }),
		onSuccess: () => {
			toast.success('Zásilka byla vytvořena.');
			queryClient.invalidateQueries({ queryKey: ['outbound-delivery-order', id] });
		}
	});

	useValidationResultDialog([mutation.error]);

	return {
		id: 'create-shipment',
		label: 'Vytvořit zásilku',
		icon: <Truck className="h-4 w-4" />,
		shortcut: undefined,
		disabled: !id ? true : disabledReasons,
		loading: mutation.isPending,
		run: () => {
			if (id) {
				mutation.mutate();
			}
		}
	};
};
